import React from 'react';
import Legend, { LegendGroup } from '@ui/legend/Legend';
import { marketRegionStateClusterBgClasses, marketRegionStateClusterNames } from '@app/model/market_area/MarketRegionStateCluster';
import { MarketPaceSource } from '@app/model/market_insight/MarketPace';
import { methodLines, PACE_LEGEND_ORDER, PACE_VERDICT_SHORT } from './MarketPaceText';
import { CLUSTER_ORDER, CLUSTER_TINT, PACE_CLASS_OF, PACE_MARK_CLASS } from './MarketPaceStyles';
import { PaceChip } from './PaceChip';

// The legend of the panel (design system Legend, v1.4.3). The chart view: demand dots and pace
// squares. The calendar view: demand tints and pace chips ("no mark" = in line). The (i) next to
// "Your pace vs market" holds the method, with the data source of the hotel (decision P5).
type Props = {
	view: 'chart' | 'calendar',
	showPace: boolean,
	source: MarketPaceSource,
};

const MarketDemandLegend: React.FunctionComponent<Props> = ({ view, showPace, source }) => {
	const demand: LegendGroup = {
		label: 'Demand',
		items: CLUSTER_ORDER.map(cluster => view === 'chart'
			? { label: marketRegionStateClusterNames[cluster], mark: 'dot' as const, markClassName: marketRegionStateClusterBgClasses[cluster] }
			: { label: marketRegionStateClusterNames[cluster], mark: 'tint' as const, markClassName: CLUSTER_TINT[cluster] }),
	};
	const info = {
		label: 'How the pace comparison works',
		title: 'How we compare your pace',
		content: <>{methodLines(source).map(line => <span key={line} className="mt-1.5 block first:mt-0">{line}</span>)}</>,
	};
	const pace: LegendGroup = view === 'chart'
		? {
			label: 'Your pace vs market', info,
			items: PACE_LEGEND_ORDER.map(verdict => ({ label: PACE_VERDICT_SHORT[verdict], mark: 'square' as const, markClassName: PACE_MARK_CLASS[PACE_CLASS_OF[verdict]] })),
		}
		: {
			label: 'Your pace vs market', info,
			items: PACE_LEGEND_ORDER.filter(verdict => verdict !== 'IN_LINE')
				.map(verdict => ({ label: PACE_VERDICT_SHORT[verdict], icon: <PaceChip verdict={verdict} /> })),
			note: 'No mark: in line',
		};
	return <Legend groups={showPace ? [demand, pace] : [demand]} />;
};

export default MarketDemandLegend;
